module.exports = __webpack_public_path__ + "img/IMG_9928_L_Foamcore.a68942a6.jpg";